import { CheckmarkIcon } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import Link from '~/App/shared/components/Link';
import { translateRoute } from '~/App/shared/localization';
import { useTranslation } from '~/Locale';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CircleCheck = styled.div`
  margin-right: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 4rem;
  color: ${({ theme }) => theme.colors.common.white};
  background-color: ${({ theme }) => theme.colors.secondary.main};

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 1.75rem;
    position: initial;
    margin-top: 0;
  }
`;

const TextContainer = styled.div`
  flex: 1;

  a {
    font-size: 0.85rem;
    font-weight: 500;
  }
`;

interface Props {
  orderId: number;
}

const CompletedCheckoutStatus = ({ orderId }: Props) => {
  const { t } = useTranslation();

  return (
    <Container data-testid="completed-checkout-status">
      <CircleCheck>
        <CheckmarkIcon />
      </CircleCheck>

      <TextContainer>
        <p>{t('You have completed the checkout')}</p>
        <Link
          to={translateRoute(
            t,
            `/ROUTES.CHECKOUT/ROUTES.CHECKOUT_FLOW/${orderId}`
          )}
        >
          {t('Go to completed checkout')}
        </Link>
      </TextContainer>
    </Container>
  );
};

export default CompletedCheckoutStatus;
